import { useDispatch } from "react-redux";

import { useGetOrg } from "@src/api/organizations/get-organization";
import { dismissAlert } from "@src/store/slices/appSettings";

export const useDismissAlert = () => {
  const org = useGetOrg();
  const dispatch = useDispatch();

  return (alertId: string) => {
    dispatch(
      dismissAlert({
        orgId: org.data.org.id,
        alertId,
      })
    );
  };
};
